import { FaInfoCircle } from "react-icons/fa"
import { Box, Heading, Text, Icon, Spinner } from "@chakra-ui/react"
import { IconType } from "react-icons/lib"
export interface InformativeProps {
  heading?: string
  text?: string
  icon?: IconType
  loading?: boolean
  hideText?: boolean
}

function Informative({ heading, text, icon = FaInfoCircle, loading = false, hideText = false }: InformativeProps) {
  return (
    <Box textAlign="center" py={hideText ? 0 : 20} px={hideText ? 0 : 6} data-testid="informative">
      {loading ? (
        <Box>
          <Spinner />
        </Box>
      ) : (
        <Icon as={icon} boxSize={"50px"} color={"blue.500"} mb="6" />
      )}
      {heading && <Heading as="h3">{heading}</Heading>}
      {text && (
        <Text display={hideText ? "none" : "block"} mt="2">
          {text}
        </Text>
      )}
    </Box>
  )
}

export default Informative
